export default __webpack_public_path__ + "static/media/welcome-1.fda2418b.jpg";